module.exports = __webpack_public_path__ + "img/2.893e445f.png";